// extracted by mini-css-extract-plugin
export default {"wrapper":"ov-z","button":"pv-z","alternate":"qv-z","disabled":"rv-z","paymentWarning":"sv-z","fadeIn":"tv-z"};